<template>
  <div id="app">
    <usercentrics-loader />
    <div
      v-if="showStoreCodeFallbackBar"
      class="store-code-fallback-bar"
      role="status"
    >
      {{ $t('Store code default banner', { code: activeStoreCode }) }}
    </div>
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { storeCode } from '@vue-storefront/core/lib/multistore'
import UsercentricsLoader from 'theme/components/core/UsercentricsLoader.vue'
const DefaultLayout = () => import(/* webpackChunkName: "vsf-layout-default" */ './layouts/Default')
const EmptyLayout = () => import(/* webpackChunkName: "vsf-layout-empty" */ './layouts/Empty')
const MinimalLayout = () => import(/* webpackChunkName: "vsf-layout-minimal" */ './layouts/Minimal')

// Zaun24 mark

export default {
  data () {
    return {
      ordersData: []
    }
  },
  computed: {
    ...mapState({
      overlayActive: state => state.ui.overlay,
      storeView: state => state.storeView
    }),
    showStoreCodeFallbackBar () {
      return !!(this.storeView && this.storeView.usedDefaultStoreFallback)
    },
    activeStoreCode () {
      return storeCode() || (this.storeView && this.storeView.storeCode) || ''
    },
    layout () {
      return `${(this.$route.meta.layout || 'default')}-layout`
    }
  },
  components: {
    UsercentricsLoader,
    DefaultLayout,
    EmptyLayout,
    MinimalLayout
  }
}
</script>

<style lang="scss" scoped>
.store-code-fallback-bar {
  position: relative;
  z-index: 10001;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 14px;
  line-height: 1.35;
  text-align: center;
  color: #1a1a1a;
  background: #ffe08a;
  border-bottom: 1px solid #e6c34d;
}
</style>

<style lang="scss" src="theme/css/main.scss"></style>
